import axios from 'axios';

// В dev vite-proxy переписывает /api на http://sd-backend:8000.
// В prod (статика nginx) /api будет проходить на backend через NPM.
export const api = axios.create({
  baseURL: '/',
  timeout: 15000,
});
